import { endOfDay, lastDayOfMonth, startOfDay, startOfMonth, startOfWeek } from "date-fns";
import { Maybe } from "../../models/generated/graphql";

export const options = ["custom", "lastMonth", "last3months", "last6months", "last12months", "lastCalYear", "y2d", "sinceStart", "allTime"];
export const caseEventLogOptions = ["today", "thisWeek", "thisMonth", "lastQuarter", "custom"];

export type DateRangeLabelOptions = (typeof options)[number] | (typeof caseEventLogOptions)[number];

export const getRangeByOption = (o: DateRangeLabelOptions, contractStartDate?: Date | null): [Maybe<Date>, Maybe<Date>] => {
	const cMonth = new Date().getMonth();
	const cYear = new Date().getFullYear();
	const lastMonth = cMonth - 1;
	const firsDayOfLastMonth = new Date(cYear, lastMonth, 1);

	switch (o) {
		case "today":
			return [startOfDay(new Date()), endOfDay(new Date())];
		case "thisWeek":
			return [startOfWeek(new Date()), new Date()];
		case "thisMonth":
			return [startOfMonth(new Date()), new Date()];
		case "lastMonth": {
			return [new Date(firsDayOfLastMonth), lastDayOfMonth(firsDayOfLastMonth)];
		}
		case "lastQuarter":
		case "last3months": {
			const currentMonthLess3 = cMonth - 3;
			const firsDayOfCurrentMonthLess3 = new Date(cYear, currentMonthLess3, 1);

			return [new Date(firsDayOfCurrentMonthLess3), lastDayOfMonth(firsDayOfLastMonth)];
		}
		case "last6months": {
			const currentMonthLess6 = cMonth - 6;
			const firsDayOfCurrentMonthLess6 = new Date(cYear, currentMonthLess6, 1);

			return [new Date(firsDayOfCurrentMonthLess6), lastDayOfMonth(firsDayOfLastMonth)];
		}
		case "last12months": {
			const currentMonthLess12 = cMonth - 12;
			const firsDayOfCurrentMonthLess12 = new Date(cYear, currentMonthLess12, 1);

			return [new Date(firsDayOfCurrentMonthLess12), lastDayOfMonth(firsDayOfLastMonth)];
		}
		case "lastCalYear": {
			return [new Date(cYear - 1, 0, 1), new Date(cYear - 1, 11, 31)];
		}
		case "y2d": {
			return [new Date(cYear, 0, 1), new Date()];
		}
		case "sinceStart": {
			return [contractStartDate || null, null];
		}
		default:
			return [null, null];
	}
};
